import { isFunction } from 'lodash';

type BlurCapableElement = {
    tagName?: string;
    blur?: () => void;
};

/**
 * Blur the currently focused text input so the virtual keyboard can dismiss.
 */
export const blurActiveTextInput = (): void => {
    const activeElement = document.activeElement as BlurCapableElement | null;

    if (!activeElement || !isFunction(activeElement.blur)) return;

    const isTextInput = activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA';

    if (!isTextInput) return;

    activeElement.blur();
};

export default blurActiveTextInput;
